<template>
  <div class="books-literature">
    <!-- 抬头 -->
    <div class="head">
      <div class="head-left">
        <h4>文献列表</h4>
      </div>
      <div class="head-right">
        <div style="width: 330px">
          <el-input
            :clearable="true"
            placeholder="请输入文献标题"
            v-model="title"
            clearable
            @change="wxchange"
            :maxlength="330"
          >
          </el-input>
        </div>
        <div style="margin: 0 15px 0 15px; width: 330px">
          <el-input
            :clearable="true"
            placeholder="请输入专家姓名"
            v-model="expert_name"
            clearable
            @change="zjchange"
            :maxlength="330"
          >
          </el-input>
        </div>

        <el-button
          size="medium"
          style="background: #484c7f; color: #fff"
          @click="searchExpert"
          >搜索</el-button
        >
      </div>
    </div>
    <!-- 抬头结束 -->
    <!-- 内容 -->
    <!-- <ul class="books-literature-box">
      <li
        class="books-literature-box-item"
        v-for="(item, index) in booksLiterature.list"
      >
        <div class="books-literature-box-item-left">
          <div class="books-literature-box-item-name">{{ item.title }}</div>
          <div class="books-literature-box-item-xia">
            <div class="books-literature-box-item-ck">
              <div class="books-literature-box-item-ck-img">
                <img src="../../assets/image/books/yan.png" />
              </div>
              <div class="books-literature-box-item-name">{{ item.views }}</div>
            </div>
            <div class="books-literature-box-item-zj">
              <div class="books-literature-box-item-zj-img">
                <img src="../../assets/image/books/zhuanjia.png" />
              </div>
              <div class="books-literature-box-item-name">
                {{ item.expert_text }}
              </div>
            </div>
          </div>
        </div>
        <div class="books-literature-box-item-right" @click="viewsClick(item)">
          <div class="books-literature-box-item-right-img">
            <img src="../../assets/image/books/chakan.png" />
          </div>
          <div>查看</div>
        </div>
      </li>
      <div class="available" v-if="booksLiterature.list.length == 0">
        暂无数据
      </div>
    </ul> -->
    <div class="table-box">
      <el-table
        :data="booksLiterature.list"
        style="width: 100%; cursor: pointer"
        stripe
        @row-click="viewsClick"
        :row-style="{ height: '56px' }"
      >
        <el-table-column prop="title" label="文献标题"> </el-table-column>
        <el-table-column prop="views" label="阅读数量" width="200">
        </el-table-column>
        <el-table-column prop="expert_text" label="专家" width="200">
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200">
          <!-- <div
            class="books-literature-box-item-right"
            @click="viewsClick(item)"
          > 
            <div class="books-literature-box-item-right-img">
              <img src="../../assets/image/books/chakan.png" />
            </div>
            <div>查看</div> 
          </div> -->
          <div class="yuedeu-box">
            <div class="yuedeu-box-img">
              <img src="@/assets/image/books/chakan.png" />
            </div>
            <div class="yuedeu-box-name">阅读文献</div>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <!-- 内容 结束 -->
    <!-- 分页 -->
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :current-page.sync="currentPage"
        :page-count="booksLiterature.pages"
      >
      </el-pagination>
    </div>
    <!-- <iframe :src="url "></iframe> -->
  </div>
</template>

<script>
export default {
  name: "booksLiterature",
  data() {
    return {
      url: "",
      booksLiterature: { list: [] },
      title: "", //文献标题
      expert_name: "", //专家姓名
      pagesize: 15, //每页显示条目个数
      currentPage: 1, //当前页数
    };
  },
  activated() {
    this.getbooksLiteratureList();
  },
  methods: {
    //获取列表
    async getbooksLiteratureList() {
      const { data: data } = await this.$http.post("literature/list", {
        archive_id: "", //档案主键id
        ent_id: this.$route.query.id, //企业
        expert_id: "", //专家
        title: this.title, //文献
        expert_name: this.expert_name, //专家
        page: this.currentPage, //分页
        limit: this.pagesize, //条数
      });
      this.booksLiterature = data.data;
      this.$Spin.hide();
    },
    //文献回车搜索
    wxchange(value) {
      this.title = value;
      this.currentPage = 1;
      setTimeout(() => {
        this.getbooksLiteratureList();
      }, 500);
      this.$Spin.show();
    },
    //专家回车搜索
    zjchange(value) {
      this.expert_name = value;
      this.currentPage = 1;
      setTimeout(() => {
        this.getbooksLiteratureList();
      }, 500);
      this.$Spin.show();
    },
    //查看
    async viewsClick(row, column, event) {
      const { data: data } = await this.$http.post("literature/detail", {
        id: row.id,
      });
      window.open(data.data.file_url);
      // location.href = data.data.file_url;

      // this.url = `https://view.officeapps.live.com/op/view.aspx?src=${data.data.file_url}`
      // let str = data.data.file_url.substr(data.data.file_url.length - 3, 3)
      // if (str == 'jpg' || str == 'pdf') {
      //   window.open(data.data.file_url)
      // } else {
      //   window.open(this.url)
      // }
    },
    //点击搜索
    searchExpert() {
      this.currentPage = 1;
      setTimeout(() => {
        this.getbooksLiteratureList();
      }, 500);
      this.$Spin.show();
    },
    //点击每一页
    currentchange(e) {
      this.currentPage = e;
      document.querySelector(".el-main").scrollTop = 0;
      setTimeout(() => {
        this.getbooksLiteratureList();
      }, 500);
      this.$Spin.show();
    },
    //上一页
    prevClick(e) {
      this.currentPage = e;
      document.querySelector(".el-main").scrollTop = 0;
      setTimeout(() => {
        this.getbooksLiteratureList();
      }, 500);
      this.$Spin.show();
    },
    //下一页
    nextClick(e) {
      this.currentPage = e;
      document.querySelector(".el-main").scrollTop = 0;
      setTimeout(() => {
        this.getbooksLiteratureList();
      }, 500);
      this.$Spin.show();
    },
  },
};
</script>
<style lang="less" scoped>
.books-literature {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    .head-left {
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }
    .head-right {
      display: flex;
    }
  }
  .books-literature-box {
    padding-top: 40px;
    width: 100%;
    min-height: 645px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

    .books-literature-box-item {
      cursor: pointer;
      padding: 0 70px 65px 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .books-literature-box-item-left {
        flex: 1;
        .books-literature-box-item-name {
          font-size: 16px;
          color: #212529;
        }

        .books-literature-box-item-xia {
          margin-top: 16px;
          display: flex;
          align-items: center;
          .books-literature-box-item-ck {
            display: flex;
            align-items: center;
            padding: 6px 12px;
            background-color: #f3f3f3;
            border: 1px solid #cecece;
            border-radius: 6px;
            margin-right: 83px;
            .books-literature-box-item-ck-img {
              width: 20px;
              height: 14px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .books-literature-box-item-zj {
            display: flex;
            align-items: center;
            padding: 6px 12px;
            background-color: #f3f3f3;
            border: 1px solid #cecece;
            border-radius: 6px;
            .books-literature-box-item-zj-img {
              width: 13px;
              height: 18px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .books-literature-box-item-name {
            font-size: 13px;
            color: #b2b2b2;
            margin-left: 6px;
          }
        }
      }

      .books-literature-box-item-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 200px;
        font-size: 16px;
        color: #212529;

        .books-literature-box-item-right-img {
          width: 23px;
          height: 23px;
          margin-right: 7px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .page {
    margin-top: 30px;
    text-align: right;
  }

  .available {
    display: flex;
    justify-content: center;
    margin-top: 240px;
    color: #756bb1;
  }

  .table-box {
    background-color: #fff;
    padding: 40px 28px;
  }

  .yuedeu-box {
    display: flex;
    align-items: center;
    .yuedeu-box-img {
      width: 23px;
      height: 23px;
      margin-right: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .yuedeu-box:hover {
    color: #2557e1 !important;
  }
}
</style>
